import { ContactPage } from './contact/contact/contact';
import { ContactInfo } from './contact/contactinfo/contactinfo';
import { AddressBookList } from './addressbook/list/addressbooklist';
import { AddressBookInfo } from './addressbook/detail/addressbookinfo';
import { HelpCenter } from './helpcenter/overview/helpcenter';
import { ProblemList } from './helpcenter/problemlist/problemlist';
import { ProblemDetail } from './helpcenter/problemdetail/problemdetail';
import { UnifiedAddressBookList } from './unifiedaddressbook/list/unifiedaddressbooklist';

export const DAILYOFFICE_INDEX = [
  ContactPage,
  ContactInfo,
  AddressBookList,
  AddressBookInfo,
  HelpCenter,
  ProblemList,
  ProblemDetail,
  UnifiedAddressBookList,
];



// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/index.ts